type CountryOption = {
  value?: unknown;
};

const normalizeCountry = (value: unknown) =>
  String(value ?? "")
    .trim()
    .toUpperCase();

export const getPlanCountryLimit = (plan: unknown): number => {
  if (!plan || typeof plan !== "object") {
    return Number.POSITIVE_INFINITY;
  }
  const rawLimit = (plan as { limits?: Record<string, unknown> }).limits?.[
    "countries.max"
  ];
  const limit = Number(rawLimit);
  return Number.isFinite(limit) && limit >= 0
    ? limit
    : Number.POSITIVE_INFINITY;
};

export const isPromptCountryLimitReached = ({
  plan,
  predefinedCountries,
  promptCountry,
  brandCountry,
}: {
  plan: unknown;
  predefinedCountries: CountryOption[];
  promptCountry: unknown;
  brandCountry?: unknown;
}) => {
  const normalizedPromptCountry = normalizeCountry(promptCountry);
  if (!normalizedPromptCountry) return false;

  const countryLimit = getPlanCountryLimit(plan);
  if (!Number.isFinite(countryLimit)) return false;

  const existingCountries = new Set(
    predefinedCountries
      .map((country) => normalizeCountry(country?.value))
      .filter(Boolean),
  );
  const normalizedBrandCountry = normalizeCountry(brandCountry);
  if (normalizedBrandCountry) {
    existingCountries.add(normalizedBrandCountry);
  }

  return (
    existingCountries.size >= countryLimit &&
    !existingCountries.has(normalizedPromptCountry)
  );
};
